import Model from "../Model";

class BackZone extends Model{

    buildUrl ({ param }) {
        return ['zonelink', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new BackZone;